import { Component } from '@angular/core';

@Component({
  selector: 'app-soa-request-form',
  templateUrl: './soa-request-form.component.html',
  styleUrls: ['../entry-forms/entry-forms.scss', './soa-request-form.component.scss'],
})
export class SoaRequestFormComponent {}
